<template>
	<div class="box" v-if="showTip">
		<top-nav ref="nav" :showBack="false" bgColor="#F6F6FB"><span class="color_back">退款</span></top-nav>
		<template v-if="!pageLoading && !errorMsg">
			<div class="card">
				<div class="tip_title">商品信息：</div>
				<div class="row">
					<div class="row_title">商品名称：</div>
					<div>{{ insMasterProductInfoVo.insProductName }}</div>
				</div>
				<div class="row">
					<div class="row_title">计划名称：</div>
					<div>{{ insMasterProductInfoVo.comboName }}</div>
				</div>
			</div>
			<div class="card">
				<div class="tip_title">保障内容：</div>
				<div v-for="(item, index) in insMasterContentInfoVos" :key="index">
					<div class="row">
						<div class="row_title max_w">{{ item.contentName }}</div>
						<div>{{ item.price }}</div>
					</div>
					<div class="remark">{{ item.contentRemark }}</div>
				</div>
			</div>
			<div class="card">
				<div class="tip_title">投保信息：</div>
				<div v-for="(item, index) in insMasterBillInfoVos" :key="item.billCode" :class="index < insMasterBillInfoVos.length - 1 ? 'row_box' : ''">
					<div :class="['row', index > 0 ? 'pt_2' : '']">
						<div class="row_title">订单号：</div>
						<div class="row_content">{{ item.billCode }}</div>
					</div>
					<div class="row">
						<div class="row_title">投保人数：</div>
						<div v-if="insureType == 2">{{ item.assuredNum }}人</div>
						<div v-else>{{ assuredList.length }}人</div>
					</div>
					<div class="row" v-if="item.insureType == 2 || (item.insureType === 1 && item.billState != 4 && item.billState != 5)">
						<div class="row_title">保障期限：</div>
						<div class="row_content">{{ item.enableDate }}<span v-if="getActualShow(item)">(以实际出单时间为准)</span> ~ {{ item.disEnableDate }}</div>
					</div>
					<div class="row">
						<div class="row_title">保障天数：</div>
						<div>{{ getDays(item) }}天</div>
					</div>
					<div class="row" v-if="item?.remark">
						<div class="row_title">活动备注：</div>
						<div>{{ item.remark }}</div>
					</div>
					<div class="row">
						<div class="row_title">总保费：</div>
						<div class="color_red">{{ item.premium }}元</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="tip_title">投保人信息：</div>
				<div class="row">
					<div class="row_title">姓名：</div>
					<div>{{ insMasterInsureInfoVo.insName }}</div>
				</div>
				<div class="row">
					<div class="row_title">证件号：</div>
					<div>{{ insMasterInsureInfoVo.insCredentials }}</div>
				</div>
			</div>

			<div class="pb_10">
				<div class="card">
					<div class="tip_title">被保险人名单（共{{ assuredList.length }}人）：</div>
					<table style="width: 100%; text-align: center; border-collapse: collapse; border-color: #eee; margin-top: 0.2rem" border="1">
						<thead>
							<tr>
								<th>姓名</th>
								<th>证件号码</th>
								<th>保费</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in assuredList" :key="item.certificateContent">
								<td>{{ item.name }}</td>
								<td>{{ !item.eyeShow ? setEncrypt(item.certificateContent) : item.certificateContent }}<van-icon @click="handleEye(item)" name="eye-o" class="ml_4" v-if="!item.eyeShow" /></td>
								<td>{{ item.premium }}元</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="tip_copyright" >本系统已获软件著作权，受《中华人民共和国著作权法》和《计算机软件保护条例》的保护，未经许可请勿擅自使用、复制、传播软件。</div>

			</div>
			<div class="tip_copyright" v-if="!(insMasterBillInfoVos[0]?.billState == 2 && insMasterBillInfoVos[0]?.payState == 0)">本系统已获软件著作权，受《中华人民共和国著作权法》和《计算机软件保护条例》的保护，未经许可请勿擅自使用、复制、传播软件。</div>


			<div class="p_f " v-if="insMasterBillInfoVos[0]?.billState == 2 && insMasterBillInfoVos[0]?.payState == 0">
				<div class="tip_title mb_3">请输入退款账户信息：</div>
                <van-form ref="form" class="form_info" :border="false">
                    <van-cell-group >
                        <van-field label="姓名" v-model.trim="userInfo.userName" required label-class="cell_title" :rules="rules.userName" placeholder="请填写被保人姓名" />
                        <van-field label="银行卡号" v-model.trim="userInfo.cardNum" required label-class="cell_title" :rules="rules.cardNum" placeholder="请填写被保人证件号码" />
                    </van-cell-group>
                </van-form>
                <van-button type="primary" class="bg_main" @click="handleRefund">退款</van-button>
			</div>
			<div v-else class="info_tip">
				<div>{{ insMasterBillInfoVos[0]?.payState == 0 ? '订单未支付' : '订单已支付' }}</div>
			</div>
		</template>
		<template v-else>
			<van-loading v-if="!errorMsg" vertical class="loading"> 加载中...</van-loading>
			<div v-else class="error_msg">{{ errorMsg }}</div>
		</template>
	</div>
	<div v-else class="weChat_warning"><h4>请在微信/支付宝打开</h4></div>
</template>

<script>
import { Button, Loading, Cell, CellGroup, Toast, Icon ,Form,Field} from 'vant';
import { loginNoPwd,  getBillInfo } from '@/request/api';
import { http_getInsCustomerPayArguByOutBillId, http_selectInsMasterBillDetails, http_getAllAssuredInfoByBillId,  } from '@/request/zhifu';
import moment from 'moment';
import Mtils from 'mtils';

export default {
	name: 'confirmBook',
	components: {
		[Button.name]: Button,
		[Loading.name]: Loading,
		[Toast.name]: Toast,
		[Icon.name]: Icon,
		[Field.name]: Field,
		[Form.name]: Form,
        [Cell.name]: Cell,
		[CellGroup.name]: CellGroup,
	},
	data() {
		return {
            
			imgUrl: '',
			docShow: false,
			billId: '',
			userDesc: '',
			userId: '',
			insMasterProductInfoVo: {},
			insMasterBillInfoVos: [],
			insMasterInsureInfoVo: {},
			assuredList: [],
			version: '0',
			proId: '',
			comboId: '',
			insMasterContentInfoVos: [],
			information: {},
			btnLoading: false,
			showTip: false,
			billState: {
				1: '订单待核保',
				2: '订单待支付',
				3: '订单已支付',
				4: '订单已承保',
				5: '订单已退保',
				7: '订单正在出单',
				9: '订单已失效',
			},
			pageLoading: true,
			billInfo: {},
			insureType: '',
			errorMsg: '',
			allBiiIds:'',
            userInfo:{
                name:'',
                cardNum:''
            },
            rules: {
				userName: [{ required: true, message: '' }],
				cardNum: [
					{ required: true, message: '' },
                    { validator: this.bankNumberCheck, message: '银行卡号码有误' },
				],
			},
		};
	},
	computed: {
		totalPrice() {
			return this.insMasterBillInfoVos
				.reduce(function (pre, cur) {
					return pre + cur.premium;
				}, 0)
				.toFixed(2);
		},
	},

	watch: {
		$route: {
			handler: function (val) {
				this.env = this.$base.getEnv();
				if (this.env !== 'wx' && this.env !== 'zfb' && this.$base.isDev()) {
					this.showTip = false;
					return false;
				}
				this.showTip = true;
				let params = val.query;
				if (!params.billId) {
					return false;
				}
				this.getOrderId();
			},
			immediate: true,
		},
	},
	methods: {
		//获取订单id
		getOrderId() {
			this.pageLoading = true;
			http_getInsCustomerPayArguByOutBillId(this.$route.query.billId)
				.then(res => {
					this.billId = res.billId;
					this.version = res.versions;
					this.proId = res.proId;
					this.comboId = res.comboId;
					this.insureType = res.insureType;
					localStorage.setItem('bookBillId', res.billId);
					this.userDesc = res.userDesc;
					this.login().then(res => {
						if (this.insureType == 1) {
							this.getOrderDetailOne();
						} else {
							this.getOrderDetail();
						}
						this.getAssured();
					});
				})
				.catch(err => {
					this.pageLoading = false;
					this.errorMsg = err.message;
				});
		},

		//获取订单详情拆单
		getOrderDetail() {
			http_selectInsMasterBillDetails(this.billId)
				.then(res => {
					this.insMasterProductInfoVo = res.insMasterProductInfoVo;
					this.insMasterInsureInfoVo = res.insMasterInsureInfoVo;
					this.insMasterBillInfoVos = res.insMasterBillInfoVos;
					this.allBiiIds = res.insMasterBillInfoVos.map(item => item.billId).join(",");
					this.insMasterContentInfoVos = res.insMasterContentInfoVos;
					this.$store.commit('set_billId', this.allBiiIds);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},

		//不拆单
		getOrderDetailOne() {
			getBillInfo(this.billId)
				.then(res => {
					this.insMasterProductInfoVo = { ...res.billInfo, comboName: res.comboName };
					this.insMasterInsureInfoVo = res.billInsure;
					this.insMasterContentInfoVos = res.productContentList;
					this.insMasterBillInfoVos = [res.billInfo];
					this.allBiiIds = res.billInfo.billId;
					this.$store.commit('set_billId', this.allBiiIds);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},

		//被保险人
		getAssured() {
			http_getAllAssuredInfoByBillId(this.billId).then(res => {
				this.assuredList = res.map(item => ({ ...item, eyeShow: false }));
			});
		},

		login() {
			return new Promise(resolve => {
				loginNoPwd(this.userDesc).then(res => {
					this.userId = res.userInfo.id;
					resolve();
				});
			});
		},


		handleRefund() {
            this.$refs.form.validate().then(res=>{
                console.log(55,res)
            })
		},

		getDays(item) {
			const start = moment(item.enableDate);
			const end = moment(item.disEnableDate);
			return end.diff(start, 'days') + 1;
		},

		getActualShow(item) {
			return moment().format('YYYY-MM-DD') == moment(item.enableDate).format('YYYY-MM-DD') && item.billState == 2 && item.payState == 0;
		},

		// 证件号脱敏
		setEncrypt(idNumber) {
			let desensitizedIdNumber = idNumber;
			if (idNumber && Mtils.validation.isIdCard(idNumber)) {
				const pattern = /(\d{4})\d+(\d{3})/; // 匹配身份证号码的前四位和后三位
				const replacement = '$1*********$2'; // 替换为前四位+星号+后三位
				desensitizedIdNumber = idNumber.replace(pattern, replacement);
			} else {
				const firstPart = idNumber.substring(0, 2);
				const lastPart = idNumber.substring(5);
				desensitizedIdNumber = `${firstPart}***${lastPart}`;
			}
			return desensitizedIdNumber;
		},

		handleEye(item) {
			this.assuredList.forEach(i => {
				i.eyeShow = false;
				if (i.certificateContent === item.certificateContent) {
					i.eyeShow = true;
				}
			});
		},
        // 银行卡卡号校验
		bankNumberCheck(val) {
            if (!Mtils.validation.isBankCard(val)) {
                return false
            }
			return true;
		},
	},
};
</script>

<style lang="scss" scoped>
.box {
	height: 100vh;
	padding: 0 0.1rem;
	background-color: #f9faff;
	line-height: 0.46rem;
	position: relative;
}

.card {
	font-size: 0.25rem;
	background-color: #fff;
	margin-top: 0.2rem;
	padding: 0.2rem;
	border-radius: 0.1rem;
	box-shadow: 0rem 0.04rem 0.16rem 0rem rgba(0, 0, 0, 0.1);
}

.color_active {
	background-color: #f1f6fc;
}

.color_back {
	color: $font_color_main;
}

.color_main {
	color: $color_main;
}

.tip_title {
	font-size: 0.28rem;
	font-weight: bold;
}

.mb_3{
    margin-bottom: 0.2rem;
}

.tip {
	color: $font_color_info;
	margin-top: 0.2rem;
}

.text_indent {
	text-indent: 0.56rem;
}

.row {
	display: flex;
	justify-content: space-between;
	align-items: baseline;
}
.row_content {
	text-align: right;
	flex: 1;
	word-break: break-all;
}

.row_title {
	min-width: 100px;
	margin-top: 0.1rem;
}

.remark {
	color: $danger;
	font-size: 0.24rem;
}

.pb_10 {
	padding-bottom: 36vh;
}

.p_f {
	position: fixed;
	bottom: 0;
	left: 0;
	background-color: #fff;
	padding: 0.4rem 0.2rem;
	box-shadow: 0rem 0.04rem 0.2rem 0rem rgba(0, 0, 0, 0.2);
    width: 100%;
    box-sizing: border-box;
    min-height: 30vh;
}

.flex_center {
	display: flex;
	justify-content: center;
	margin-top: 0.4rem;
}

.bg_main {
	background-color: $color_main;
	border-color: $color_main;
    width: 100%;
}

.color_red {
	color: $danger;
}

.max_w {
	max-width: 68vw;
}

.link {
	color: $color_main;
}

.info_tip {
	color: $danger;
	font-size: 0.4rem;
	text-align: center;
	position: fixed;
	bottom: 0;
	left: 0;
	background-color: #fff;
	padding: 0.4rem 0;
	width: 100%;
	box-shadow: 0rem 0.04rem 0.2rem 0rem rgba(0, 0, 0, 0.2);
}

.loading {
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 0.26rem;
}

.row_box {
	border-bottom: solid 1px #eee;
	padding-bottom: 0.2rem;
}

.pt_2 {
	padding-top: 0.1rem;
}

.error_msg {
	font-size: 0.26rem;
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.ml_4 {
	margin-left: 0.1rem;
}

.form_info{
    height: 2rem;
}
</style>
